import { render, staticRenderFns } from "./BuyoutEventDetail.vue?vue&type=template&id=43474fda"
import script from "./BuyoutEventDetail.vue?vue&type=script&lang=js"
export * from "./BuyoutEventDetail.vue?vue&type=script&lang=js"
import style0 from "./BuyoutEventDetail.vue?vue&type=style&index=0&id=43474fda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports